var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleMainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10526 4.5H17.8947C18.7813 4.5 19.5 5.2187 19.5 6.10526C19.5 6.99183 18.7813 7.71053 17.8947 7.71053H6.10526C5.2187 7.71053 4.5 6.99183 4.5 6.10526C4.5 5.2187 5.2187 4.5 6.10526 4.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10526 10.3945H13.8947C14.7813 10.3945 15.5 11.1132 15.5 11.9998C15.5 12.8864 14.7813 13.6051 13.8947 13.6051H6.10526C5.2187 13.6051 4.5 12.8864 4.5 11.9998C4.5 11.1132 5.2187 10.3945 6.10526 10.3945Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1053 16.2891H17.8947C18.7813 16.2891 19.5 17.0078 19.5 17.8943C19.5 18.7809 18.7813 19.4996 17.8947 19.4996H10.1053C9.2187 19.4996 8.5 18.7809 8.5 17.8943C8.5 17.0078 9.2187 16.2891 10.1053 16.2891Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleMainIcon);
export default __webpack_public_path__ + "static/media/schedule-main-icon.a77f1ea35232152539396569e65bf07a.svg";
export { ForwardRef as ReactComponent };